import { useQuery } from '@apollo/client';

import { YEARLY_TERM } from 'components/PricingPackaging/constants';
import { buildPackagePricesByTerm } from 'components/PricingPackaging/utils';
import { GET_DISCOUNTED_PRICES } from 'hooks/queries/useGetDiscountedPrices';

export const useOrgPricing = () => {
  const {
    data,
    error: orgPricesError,
    loading,
  } = useQuery(GET_DISCOUNTED_PRICES);

  const orgPrices = data?.getDiscountedPrices || [];
  const orgPricePackages = buildPackagePricesByTerm(orgPrices);

  const getSelectedPlanAndTermPrice = (bundlePlan, term = YEARLY_TERM) => {
    if (!bundlePlan) {
      return '';
    }

    return orgPricePackages[term][bundlePlan];
  };

  return {
    getSelectedPlanAndTermPrice,
    loading,
    orgPricePackages,
    orgPrices,
    orgPricesError,
  };
};
